import React, { useState } from "react";
import {
  Box,
  Card,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  Typography,
  IconButton,
  Radio,
  RadioGroup,
  FormControlLabel,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MDButton from "components/MDButton";
import { useSelector } from "react-redux";


export default function AddCarouselPlatformModal({ closeModal }) {
  const { modalData } = useSelector((state) => state.modal);
  const {
    onPlatformSelected = () => {},
  } = modalData || {};

  // No default selection: force the user to pick a platform
  const [platform, setPlatform] = useState("");

  const handleContinue = () => {
    onPlatformSelected(platform);
    closeModal();
  };

  return (
    <Card sx={{ boxShadow: "none" }} className="select-plateform-modal">
      <DialogTitle
        id="draggable-dialog-title"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography variant="h6" fontWeight="bold">
          Select Platform
        </Typography>
        <IconButton onClick={closeModal} edge="end" size="small">
          <CloseIcon fontSize="medium" />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Box mt={1}>
          <FormControl>
            <RadioGroup
                name="platform"
                value={platform}
                onChange={(e) => setPlatform(e.target.value)}
            >
                <FormControlLabel value="Hyperwolf" control={<Radio />} label="Hyperwolf" />
                <FormControlLabel value="Hemp" control={<Radio />} label="Hemp" />
                <FormControlLabel value="Stilo" control={<Radio />} label="Stilo" />
            </RadioGroup>
            </FormControl>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 2, pt: 0, justifyContent: "center" }}>
        <MDButton
          onClick={handleContinue}
          disabled={!platform}
          sx={{ minWidth: "140px", height: "40px" }}
          color="primary"
          type="button"
          variant="contained"
        >
          Continue
        </MDButton>
        {/* <MDButton
          onClick={closeModal}
          sx={{ minWidth: "140px", height: "40px" }}
          type="button"
          variant="outlined"
          color="dark"
        >
          Cancel
        </MDButton> */}
      </DialogActions>
    </Card>
  );
}

